import { render, staticRenderFns } from "./DetailInstaller.vue?vue&type=template&id=70fd5ba8&scoped=true"
import script from "./DetailInstaller.vue?vue&type=script&lang=js"
export * from "./DetailInstaller.vue?vue&type=script&lang=js"
import style0 from "./DetailInstaller.vue?vue&type=style&index=0&id=70fd5ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fd5ba8",
  null
  
)

export default component.exports